import defaultAttributes from "backend/defaultAttributes";
import { ICardElementWithChildren } from "backend/model/model";
import { resultSort } from "init/sort";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Query from "qpr-base/querybuilder/Query";
import { useQuery } from "react-query";

const useSearchObjects = (elementTypes: string[], periodOverride?: string) => {
  const ctx = useAppContext();
  const activePeriod = periodOverride || ctx.period;
  return useQuery(
    `data-searchobjects-${ctx.modelId}-${activePeriod}`,
    async () => {
      const finalize = (elements: ICardElementWithChildren[]) => {
        elements = elements.filter((element) => element.isreference === "0");
        return resultSort(elements);
      };

      const getCriteria = (): string => {
        if (elementTypes.length === 0) return "";
        let result = '(criteria="';
        elementTypes.forEach((elementType, index) => {
          if (index > 0) result += " OR ";
          result += `typename=\\"${elementType}\\"`;
        });
        result += '")';
        return result;
      };

      const elements = await Query(ctx.fullModelId)
        .customPath(`scorecard.measures${getCriteria()}`)
        .attributes(...defaultAttributes(activePeriod, []))
        .fetchValues<ICardElementWithChildren>();

      return finalize(elements);
    },
    {
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useSearchObjects;
